import {getNewsList, searchOrder,aboutUs,contactUs,getNewsInfo,aboutCompany} from '../utils/api'

/**
 * @description: 获取新闻列表
 * @param {type}
 * @return:
 */
function getTopNews(params,succCallback,errCallback) {
    getNewsList(params).then(res => {
        console.log('新闻列表：',res.data);
        if(res.data.status === 200){
            //全局状态管理
            succCallback(res.data.data);
        }else{
            errCallback(res.data)
        }
    })
}


/**
 * @description: 获取新闻列表
 * @param {type}
 * @return:
 */
function getNewsListInfo(params,succCallback,errCallback) {
    getNewsList(params).then(res => {
        console.log('新闻列表：',res.data);
        if(res.data.status === 200){
            //全局状态管理
            succCallback(res.data.data);
        }else{
            errCallback(res.data)
        }
    })
}

/**
 * @description: 获取新闻详情
 * @param {id}
 * @return:
 */
function getNewsDetail(params,succCallback,errCallback) {
    getNewsInfo(params).then(res => {
        console.log('查询快递单号：',res.data);
        if(res.data.status === 200){
            //全局状态管理
            succCallback(res.data.data);
        }else{
            errCallback(res.data)
        }
    })
}

/**
 * @description: 获取新闻列表
 * @param {page,limit}
 * @return:
 */
function getOrderInfo(params,succCallback,errCallback) {
    searchOrder(params).then(res => {
        console.log('查询快递单号：',res.data);
        if(res.data.status === 200){
            //全局状态管理
            succCallback(res.data);
        }else{
            errCallback(res.data)
        }
    })
}

function getCompanyInfo(params,succCallback,errCallback){
    aboutUs(params).then(res => {
        console.log('关于企业：',res.data);
        if(res.data.status === 200){
            //全局状态管理
            succCallback(res.data.data);
        }else{
            errCallback(res.data)
        }
    })
}

function getCompanyDetail(params,succCallback,errCallback){
    aboutCompany(params).then(res => {
        console.log('企业介绍：',res.data);
        if(res.data.status === 200){
            //全局状态管理
            succCallback(res.data.data);
        }else{
            errCallback(res.data)
        }
    })
}

function getContactInfo(params,succCallback,errCallback){
    contactUs(params).then(res => {
        console.log('关于企业：',res.data);
        if(res.data.status === 200){
            //全局状态管理
            succCallback(res.data.data);
        }else{
            errCallback(res.data)
        }
    })
}

export default {
    getTopNews,
    getNewsListInfo,
    getOrderInfo,
    getCompanyInfo,
    getContactInfo,
    getNewsDetail,
    getCompanyDetail
}
